import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import {
  applicationListParams,
  applicationListQueryOptions,
  applicationListSearchSchema,
  ApplicationsListPage,
} from '@/features/applications';

/** Any platform role may read applications; the detail page hides what the role cannot do. */
export const Route = createFileRoute('/_authed/applications/')({
  staticData: { tours: ['platform.applications.list'] },
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    applicationListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...applicationListQueryOptions(applicationListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // A tab, search or page change must not wait for the fetch, or the URL lags behind.
    if (cause !== 'stay') await prefetch;
  },
  component: ApplicationsListPage,
});
